import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-sell-equipment',
  templateUrl: './sell-equipment.component.html',
  styleUrls: ['./sell-equipment.component.scss']
})
export class SellEquipmentComponent implements OnInit {
  logos: string[];

  constructor(private title: Title) { }

  ngOnInit() {
    this.title.setTitle('Venta - CCCISA');
    this.logos = [
      'ametek.png',
      'brannan.png',
      'ametek.png',
      'EXTECH.png',
      'metron.png',
      'omega.png',
      'tecnocor.png',
      'wikai.png',
      'brannan.png',
      'fluke.png',
      'mitutoyo.png',
      'rochester.png',
      'torrey.png',
      'winters.png',
      'dwyer.png',
      'logtag.png',
      'ohaus.png',
      'TAYLOR.png',
      'vayremex.png'
    ];
  }
}
